import { DatePipe, TitleCasePipe } from '@angular/common'
import { Component, computed, inject, OnInit, signal } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { NavigationEnd, Router } from '@angular/router'

import { filter, map } from 'rxjs'

import { SuperAdminAlert } from 'app/_shared/interfaces/SuperAdminAlert'
import { AlertService } from 'app/_shared/services/alert.service'
import { AppConfigService } from 'app/app-config.service'
import { CartStore } from 'app/store/cart.store'
import { ConfigStore } from 'app/store/config.store'

@Component({
  selector: 'app-store-status-banner',
  imports: [TitleCasePipe, DatePipe],
  templateUrl: './store-status-banner.component.html',
  styleUrl: './store-status-banner.component.scss'
})
export class StoreStatusBannerComponent implements OnInit {
  router = inject(Router)
  cartStore = inject(CartStore)
  appConfigService = inject(AppConfigService)
  configStore = inject(ConfigStore)
  alertService = inject(AlertService)

  alerts = signal<SuperAdminAlert[]>([])

  giftToken = computed(() => this.cartStore.giftingToken())
  userToken = computed(() => this.cartStore.giftingUserToken())
  alertText = computed(() => this.configStore.config()?.settings?.alertText)
  alertTextBackground = computed(() => this.configStore.config()?.settings?.alertBackgroundColor)

  status: 'draft' | 'demo' | null = null
  popup = this.appConfigService.popupLifecycle
  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => event.urlAfterRedirects)
    ),
    { initialValue: this.router.url }
  )
  readonly isKitRoute = computed(() => {
    const currentRoute = this.currentUrl().split(/[?#]/)[0]
    return ['/kit', '/cart', '/checkout'].includes(currentRoute)
  })

  constructor() {
    const config = this.appConfigService.getAppConfig
    // Check if the status is either 'draft' or 'demo' and store it.
    if (config && (config.status === 'draft' || config.status === 'demo')) {
      this.status = config.status
    }
  }

  ngOnInit(): void {
    this.alertService.getGlobalAlerts().subscribe(alerts => {
      this.alerts.set(alerts.data)
    })
  }

  resumeGifting($event: MouseEvent) {
    $event.preventDefault()
    this.router.navigate(['kit'], {
      queryParams: { token: this.giftToken(), user_token: this.userToken() }
    })
  }

  discardGifting($event: MouseEvent) {
    $event.preventDefault()
    this.cartStore.clearCart()
    this.router.navigate(['/'])
  }
}
